import { BrandThemesEnum, ThemesEnum } from '../_enums/themes.enum';
import { ThemesTextEnum } from '../_enums/themes-text.enum';

export class ThemesUtils {
  static manageThemesTextConfig(theme: ThemesEnum | BrandThemesEnum): ThemesTextEnum {
    switch (theme) {
      case ThemesEnum.dark:
        return ThemesTextEnum.light;
      case ThemesEnum.light:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.white:
        return ThemesTextEnum.white;
      case ThemesEnum.veryLight:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.promo:
        return ThemesTextEnum.light;
      case ThemesEnum.promo2:
        return ThemesTextEnum.light;
      case ThemesEnum.promo_1:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.promo_2:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.extra:
        return ThemesTextEnum.light;
      case ThemesEnum.default:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.invert:
        return ThemesTextEnum.brandDark;
      case ThemesEnum.regular:
        return ThemesTextEnum.light;
      case ThemesEnum.colored:
        return ThemesTextEnum.light;
      case ThemesEnum.stars:
        return ThemesTextEnum.light;
      case BrandThemesEnum.brand:
        return ThemesTextEnum.light;
      case BrandThemesEnum.brandDark:
        return ThemesTextEnum.light;
      case BrandThemesEnum.brandLight:
        return ThemesTextEnum.light;
      case BrandThemesEnum.brandBase:
        return ThemesTextEnum.light;
      case ThemesEnum.success:
        return ThemesTextEnum.light;
      case ThemesEnum.lightSuccess:
        return ThemesTextEnum.light;
      case ThemesEnum.activeSuccess:
        return ThemesTextEnum.light;
      case ThemesEnum.pending:
        return ThemesTextEnum.dark;
    }
  }

  static manageThemesButtons(theme: ThemesEnum | BrandThemesEnum) {
    switch (theme) {
      case ThemesEnum.dark:
        return ThemesEnum.default;
      case ThemesEnum.light:
        return ThemesEnum.default;
      case ThemesEnum.white:
        return ThemesEnum.white;
      case ThemesEnum.promo:
        return ThemesEnum.invert;
      case ThemesEnum.promo2:
        return ThemesEnum.invert;
      case ThemesEnum.extra:
        return ThemesEnum.invert;
      case ThemesEnum.stars:
        return ThemesEnum.invert;
      case BrandThemesEnum.brand:
        return ThemesEnum.invert;
    }
    return undefined;
  }
}
